
import { Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../../../services/auth/auth.service';
import { ReactiveFormsModule, Validators, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { AdministrationService } from '../../../../services/administration/administration.service';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-signin-form',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    InputTextModule,
    CheckboxModule,
    RouterModule,
  ],
  templateUrl: './signin-form.component.html',
  styles: ``
})
export class SigninFormComponent {
  protected msalService = inject(MsalService);
  loginForm = new FormGroup({
    email: new FormControl(null, [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ]),
  });

  showPassword = false;
  isChecked = false;
  signingIn = false;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  constructor(
    private authService: AuthService,
    private messageService: MessageService
  ) { }
  adminService = inject(AdministrationService);
  async onSignIn() {
    try {
      const response = await fetch(
        environment.baseApiUrl + 'user/v1/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.loginForm.value)
        }
      );
      const data = await response.json();
      if (response.ok) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.message || 'Registration successful!'
        });
        this.loginForm.reset();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: data?.email || 'Registration failed!'
        });
        this.loginForm.reset();
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Something went wrong!'
      });
      this.loginForm.reset();
    }
  }
  onMicrosoftSignIn() {
    if (this.signingIn) return;
    this.signingIn = true;
    try {
      // After a session revocation the device must prove the human is
      // present again: skip silent SSO and force credential entry.
      const force = this.authService.consumeForcedInteractive();
      this.msalService.loginRedirect(
        force ? { scopes: environment.msalLogInRequest, prompt: 'login' } : undefined
      ).subscribe({
        error: () => {
          this.signingIn = false;
        },
      });
    } catch (error) {
      this.signingIn = false;
    }
  }
}
